import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section id="cart-content" data-nav="light" className="w-full bg-background text-foreground py-10 md:py-16">
      <div className="mx-auto max-w-[1088px] px-6 md:px-8">
        <WooCommerceCartBlock />
      </div>
    </section>;
}